<template>
  <!-- 抽屉详情 -->
  <el-dialog
    v-dragDialog
    :title="drawerTitle"
    :visible.sync="drawerVisible"
    width="600px"
    :close-on-click-modal="false"
  >
    <el-form
      :model="dataForm"
      ref="dataForm"
      label-width="120px"
      :rules="formRules"
    >
      <el-form-item label="改约时间:" prop="dates">
        <el-date-picker
          v-model="dataForm.dates"
          value-format="yyyy-MM-dd HH:mm"
          format="yyyy-MM-dd HH:mm"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="上门地址:" prop="userAddress">
        <el-input
          v-model="dataForm.userAddress"
          type="datetime"
          placeholder="请输入上门地址"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="联系电话:" prop="userPhone">
        <el-input
          v-model="dataForm.userPhone"
          type="datetime"
          placeholder="请输入联系电话"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="联系人:" prop="userName">
        <el-input
          v-model="dataForm.userName"
          type="datetime"
          placeholder="请输入联系人"
        >
        </el-input>
      </el-form-item>
      <el-form-item style="margin-top: 20px; text-align: right">
        <el-button type="success" @click="handleSubmit()">确认改约</el-button>
        <el-button type="info" @click="handleClose()">取消操作</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
    <script>
import { shopChangeBook } from "@/api/bussiness/dzopen";
import memberSelector from "@/components/memberSelector.vue";
import enumSelector2 from "@/components/enumSelector2.vue";
export default {
  components: {
    enumSelector2,
    memberSelector,
  },
  data() {
    return {
      dataForm: {
        key: "",
        userPhone: "",
        userName: "",
        userAddress: "",
        dates: [],
      },
      formRules: {
        userPhone: [
          { required: true, message: "请输入电话", trigger: "change" },
        ],
        userName: [
          { required: true, message: "请输入预约人", trigger: "change" },
        ],
        userAddress: [{ required: true, message: "请输入地址", trigger: "change" }],
        dates: [
          { required: true, message: "请选择改约时间", trigger: "change" },
        ],
      },
      drawerTitle: "",
      drawerVisible: false,
    };
  },
  methods: {
    show(row) {
      this.dataForm.key = row.Key;
      this.dataForm.userPhone = row.UserMobile?row.UserMobile:row.UserPhone;
      this.dataForm.userName = row.UserName;
      this.dataForm.dates = [];
      this.dataForm.dates.push(this.format.dateTimeFormat(row.BeginTime));
      this.dataForm.dates.push(this.format.dateTimeFormat(row.EndTime));
      this.dataForm.userAddress = row.UserAddress.receiver_address;
      this.drawerTitle = "商家改约";
      this.drawerVisible = true;
    },
    handleSubmit() {
      this.$refs["dataForm"].validate((valid) => {
        if(!valid){
          return;
        }
        let param = {
          key: this.dataForm.key,
          userPhone: this.dataForm.userPhone,
          userName: this.dataForm.userName,
          userAddress: this.dataForm.userAddress,
          beginDate: this.dataForm.dates[0],
          endDate: this.dataForm.dates[1],
        };
        shopChangeBook(param).then((response) => {
          if (response) {
            this.drawerVisible = false;
            this.msg.successMsg("操作完成！");
            this.$emit("update");
          }
        });
      });
    },
    handleClose() {
      this.drawerVisible = false;
    },
  },
  mounted() {},
};
</script>
    <style lang='scss'  scoped>
/deep/.el-tabs--border-card > .el-tabs__content {
  padding: 0;
  height: 1px;
}

/deep/.el-form-item {
  margin-bottom: 10px;
}

.tab-content {
  margin-top: -2px;
  border: 1px solid #dcdfe6;
  border-top: 0;
  padding: 15px;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
}

.row-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-self: center;
}

/deep/.el-drawer__header {
  margin-bottom: 15px;
  font-size: 18px;
  font-weight: bold;
  color: #ff862f;
}

/deep/.el-drawer__body {
  overflow-y: scroll;
}

/deep/.el-card__header {
  font-size: 16px;
}
</style>